/**
 * モーダルの共通ミックスインオブジェクト
 */
export default {
    /**
     * データ群
     */
    data() {
        return {
            _modal: null,
            modal_opened: false,
        };
    },
    /**
     * 描画後に実行される処理
     */
    mounted: function () {
        // モーダルmixinを使う為の初期化
        this.iniModal();

        // 多重モーダル制御のための階層設定
        this.multipleModal();
    },
    /**
     * 各種メソッド
     */
    methods: {
        /**
         * モーダルが開かれているか否か
         */
        isOpen: function () {
            return this._modal.hasClass('show');
        },
        /**
         * モーダルを開く
         */
        open: function () {
            bootstrap.Modal.getOrCreateInstance(this._modal[0]).show();
        },
        /**
         * モーダルを閉じる
         */
        close: function () {
            bootstrap.Modal.getOrCreateInstance(this._modal[0]).hide();
        },
        /**
         * モーダルmixinを使う為の初期化
         */
        iniModal: function (selecter = '.modal') {
            const target = '[data-view="' + $(this.$root.$el.parentElement).attr('data-view') + '"]';
            if (this.getComponent()?.classList?.contains('modal')) {
                // テンプレートのトップ要素にモーダルがある場合
                // $ (jQuery)はグローバル定義
                this._modal = $(this.getComponent()).prependTo(target);
            } else {
                // それ以外の場合はmodalを探す
                // $ (jQuery)はグローバル定義
                this._modal = $(this.getComponent()).find(selecter).first().prependTo(target);
            }
        },
        /**
         * モーダルのトップ要素を取得する
         * @returns モーダルのトップ要素
         */
        getComponent: function () {
            return (this.$refs?.modal ?? this.$el);
        },
        /**
         * 多重モーダルの制御
         *
         * 通常、モーダルを複数表示させると「オーバーレイ1→オーバーレイ2→モーダル画面1→モーダル画面2」の重なり順序になる。
         * これを「オーバーレイ1→モーダル画面1→オーバーレイ2→モーダル画面2」へ変更する。
         */
        multiModalAdjust: function () {
            // z-indexの順番を入れ替える
            const defaultZindexOvarlay = 1040;
            const defaultZindexModal   = 1050;
            const offset               = 20;
            const modalCount = $('.modal.show').length;
            for (let i = 0; i < modalCount; i++) {
                let layer = Number($('.modal.show').eq(i).attr('data-layer'));
                $('.modal.show').eq(i)
                    .css({
                        'z-index': defaultZindexModal + (offset * layer)
                    });
                $('.modal-backdrop').eq(i)
                    .css({
                        'z-index': defaultZindexOvarlay + (offset * layer),
                        //最上部以外のオーバーレイは透明にする
                        'opacity': (modalCount === layer + 1) ? 0.5 : 0
                    });
            }
            // モーダルを閉じると.modal-openが削除されてしまうのを防ぐ
            if (modalCount > 0) {
                $('body').addClass('modal-open');
            }
        },

        multipleModal: function () {
            /**
             * モーダルの表示と同時に実行されるイベント
             */
            this._modal.on('show.bs.modal', (e) => {
                // 階層情報を追記
                $(e.target).attr('data-layer', $('.modal.show').length);
                // リスナーが登録されている場合は実行
                if (typeof this.opening === 'function') {
                    this.opening(e);
                }
            });

            /**
             * モーダルの表示後に実行されるイベント
             */
            this._modal.on('shown.bs.modal', (e) => {
                // 多重モーダル制御
                this.multiModalAdjust();
                // リスナーが登録されている場合は実行
                if (typeof this.opened === 'function') {
                    this.opened(e);
                }
                this.modal_opened = true;
            });

            /**
             * モーダルの非表示と同時に実行されるイベント
             */
            this._modal.on('hide.bs.modal', (e) => {
                // Closeボタン押下時にwarningが発生するためフォーカスを外す
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                // リスナーが登録されている場合は実行
                if (typeof this.closing === 'function') {
                    this.closing(e);
                }
            });

            /**
             * モーダルの非表示後に実行されるイベント
             */
            this._modal.on('hidden.bs.modal', (e) => {
                // 多重モーダル制御
                this.multiModalAdjust();
                // リスナーが登録されている場合は実行
                if (typeof this.closed === 'function') {
                    this.closed(e);
                }
                this.modal_opened = false;
            });
        }
    }
};
